import { render, staticRenderFns } from "./Divider.vue?vue&type=template&id=15adaf6a&scoped=true&"
import script from "./Divider.vue?vue&type=script&lang=ts&"
export * from "./Divider.vue?vue&type=script&lang=ts&"
import style0 from "./Divider.vue?vue&type=style&index=0&id=15adaf6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15adaf6a",
  null
  
)

export default component.exports